module.exports = __webpack_public_path__ + "static/media/vbn-custom-3.84b076c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-custom-3.png
// module id = 210
// module chunks = 0